import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { Stack, Text } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip';

const messages = defineMessages({
	displayNameLabel: {
		id: 'search-page.common.display-name-tooltip.displayNameLabel',
		defaultMessage: 'Display name: {displayName}',
		description: 'Tooltip line showing the display name of an entity',
	},
	nameLabel: {
		id: 'search-page.common.display-name-tooltip.nameLabel',
		defaultMessage: 'Name: {name}',
		description: 'Tooltip line showing the internal/system name of an entity',
	},
});

type DisplayNameTooltipProps = {
	displayName: string;
	name: string;
	children: React.ReactElement;
};

export const DisplayNameTooltipContent = ({
	displayName,
	name,
}: {
	displayName: string;
	name: string;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Stack space="space.050">
			<Text size="small" color="color.text.inverse">
				{formatMessage(messages.displayNameLabel, { displayName })}
			</Text>
			<Text size="small" color="color.text.inverse">
				{formatMessage(messages.nameLabel, { name })}
			</Text>
		</Stack>
	);
};

export const DisplayNameTooltip = ({
	displayName,
	name,
	children,
}: DisplayNameTooltipProps): React.JSX.Element => (
	<Tooltip
		content={<DisplayNameTooltipContent displayName={displayName} name={name} />}
		position="bottom"
	>
		{children}
	</Tooltip>
);
